function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import { emptyFn } from '../utils';
import defaultSelectionRenderer from './defaultSelectionRenderer';
import classNames from 'classnames';
var styles = {
  "root": "Cal__Header__root",
  "landscape": "Cal__Header__landscape",
  "dateWrapper": "Cal__Header__dateWrapper",
  "day": "Cal__Header__day",
  "wrapper": "Cal__Header__wrapper",
  "blank": "Cal__Header__blank",
  "active": "Cal__Header__active",
  "year": "Cal__Header__year",
  "date": "Cal__Header__date",
  "range": "Cal__Header__range"
};

var Header = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Header, _PureComponent);

  function Header() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        layout = _this$props.layout,
        blank = _this$props.locale.blank,
        selected = _this$props.selected,
        renderSelection = _this$props.renderSelection,
        theme = _this$props.theme;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.root, (_classNames = {}, _classNames[styles.landscape] = layout === 'landscape', _classNames)),
      style: {
        backgroundColor: theme.headerColor,
        color: theme.textColor.active
      }
    }, selected && renderSelection(selected, this.props) || /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.wrapper, styles.blank)
    }, blank));
  };

  return Header;
}(PureComponent);

_defineProperty(Header, "defaultProps", {
  onYearClick: emptyFn,
  renderSelection: defaultSelectionRenderer
});

export { Header as default };